export default [
  {
    path: '/ivf-expenses',
    name: 'ivf-expenses',
    component: () => import('@/views/ivf/IvfExpenses.vue'),
  },
  {
    path: '/ivf-income',
    name: 'ivf-income',
    component: () => import('@/views/ivf/IvfIncome.vue'),
  },
  {
    path: '/ivf-balance',
    name: 'ivf-balance',
    component: () => import('@/views/ivf/IvfBalance.vue'),
  },
];
